import f from "react";
import { useFont as m } from "../../../dom/hooks/useFont.js";
import n from "./cheerfy.woff.js";
import e from "./cheerfyFont.module.scss.js";
function p({
  icon: t,
  children: r,
  className: o
}) {
  return m("Cheerfy", n), /* @__PURE__ */ f.createElement(
    "span",
    {
      "data-testid": "cheerfy-font",
      className: `${e.cheerfyFont} ${e[t]} ${o}`
    },
    r
  );
}
export {
  p as CheerfyFont
};
//# sourceMappingURL=CheerfyFont.js.map
